import { SVGAttributes } from 'react';
import { Keys } from '../../../../patient-types';
import BodySelectButton from './BodySelectButton';

const HandRightButtons = ({
  selectedKeys,
  ...props
}: SVGAttributes<SVGElement> & {
  selectedKeys: Keys;
}) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={255} height={296} fill='none' {...props}>
      <g clipPath='url(#a)'>
        <path
          fill='#F2F4FC'
          fillRule='evenodd'
          d='M130.573 264.278c-4.338 1.025-9.46 2.232-12.933 3.099-4.207.27-8.388.517-12.416-1.033-4.724-.844-8.224-2.066-12.415-4.132-5.627-2.178-9.719-5.481-14.309-9.712-7.115-4.023-10.823-11.343-15.178-17.662-5.411-6.92-9.712-14.504-15.26-21.434-2.426-3.23-6.065-9.819-11.122-17.302-4.341-6.336-9.72-17.671-11.122-21.951-1.217-2.646-4.403-10.394-6.467-15.237-2.192-4.363-5.788-10.98-8.277-14.978-2.278-3.66-2.069-12.956-2.069-16.528.604-4.734 4.515-4.76 5.432-4.906 2.798-.447 9.608-1.282 12.156.774 8.644 2.738 12.534 8.353 16.554 16.528 1.316 2.626 3.614 10.839 5.69 12.912 7.15 6.785 10.06 12.553 12.675 16.27 1.748 3.036 5.469 5.314 8.018 5.939 2.587 1.206 5.023-3.07 6.208-4.39 2.922-3.256 3.57-6.755 3.621-10.846.03-2.394.175-6.32.517-9.039.667-5.286.402-8.979.518-12.654.133-4.237-.518-9.526-.518-14.72C78.8 119.353 78.71 108.615 77.5 105c.176-4.94-.728-10.934-.986-14.779-.24-3.557-2.157-12.342-2.328-17.044-.198-5.456-1.898-14.994-2.07-20.66-.107-3.539.476-9.736.777-12.912.316-3.34.542-9.192.517-13.17-.016-2.458 1.732-6.401 4.138-8.264 3.447-3.7 10.377-5.925 14.744-2.583 5.853 4.228 5.264 8.364 6.466 10.846 1.871 3.863 1.38 8.695 1.811 12.654.323 4.087.738 8.027 0 14.72 0 2.943.279 9.328.517 13.17.259 4.171 1.521 12.454 2.069 15.496.821 4.553 1.604 10.84 1.345 15.026-.342 5.535 1.325 13.277 1.759 16.996.457 3.914 3.518 9.791 6.208 12.138 2.067 1.803 5.949-2.725 5.949-8.781-.534-8.813 1.316-18.787 1.034-22.467-.25-3.269.259-7.059.259-7.748-.418-1.67 0-3.443 0-5.164 0-3.742-1.365-8.539-1.035-13.43.204-3.004-.307-11.169-.517-15.494 0-11.252-.289-5.131-.258-10.071.022-3.27.983-9.866 1.551-12.138.163-5.289 1.532-10.826 2.587-14.462 1.68-4.654 5.979-11.514 12.157-11.879 8.574.412 10.506 3.886 10.863 9.039.141 2.022 2.759 6.067 3.104 7.961.133 2.828.084 10.963.259 14.5.21 4.24-.247 11.247 0 14.984.143 2.17-.738 8.19-.518 12.396-.981 4.283.259 10.47.259 15.236v14.72c0 6.345-2.394 13.377-1.293 18.664.463 2.223 1.774 7.019 4.138 7.419 3.958.669 7.931-6.311 9.053-17.819.688-7.326 2.069-14.708 2.069-20.66-.847-3.384 1.451-14.973 2.372-18.44 1.46-5.498 1.579-10.862 3-15-.665-6.455.471-13.117 1.353-19.5 1.294-4.72 5.314-9.695 8.795-11.104 3.362-2.951 7.156-1.722 9.311-.775 3.621 2.712 4.95 6.583 5.949 10.588.824 3.302-.086 9.125-.517 12.138.004 4.146.317 9.214 0 13.945-.311 4.65 0 8.476 0 12.208.056 5.153-1.552 9.743-2.328 20.847-1.154 7.603-3.01 13.628-4.563 21.153-1.067 5.007-1.962 10.216-2 15.776 0 4.787-2.799 14.103 3.459 14.979 3.621 4.322 8.458-8.943 10.605-12.913 2.488-5.898 5.909-14.973 7.242-19.11 1.474-4.005 4.759-9.626 5.949-13.429 3.117-6.222 4.485-11.565 5.691-15.752 2.052-4.098 5.958-7.557 8.794-8.006 3.793-.601 6.905 2.524 9.312 6.198 1.558 4.119-.206 10.49-1.035 16.528-1.578 7.834-3.611 14.763-5.395 19.269-1.285 3.227-4.523 10.324-5.986 14.579-1.731 4.187-3.737 9.771-5.387 12.85-1.814 3.384-5.112 8.203-6.252 12.698-1.625 6.489-1.811 12.041-1.811 17.045 0 3.205-1.034 6.066-1.034 10.329.398 5.291-1.677 10.212-1.035 15.495.335 1.336.259 5.337-.259 8.78.426 5.058 0 8.684-1.358 15.184-1.001 3.999-1.487 7.5-3 15-1.5 5-6.072 14.462-9 18.5-2.509 3.202-6.206 7.479-9.145 9.68-2.421 1.813-5.023 4.057-7.242 5.165-4.142 2.267-8.794 4.523-16.036 5.165-4.97-.451-10.7-2.67-13.968-3.099-4.924-2.316-10.672-3.84-16.036-4.133Z'
          clipRule='evenodd'
        />
        <path
          fill='#F2F4FC'
          fillRule='evenodd'
          d='M183.983 295.67c.264-5.548.376-14.732.619-19.103.403-7.245-.057-28.989-.769-31.869-12.459-11.288-27.754-20.728-45.631-20.728-18.801 1.863-35.547 7.338-49.733 17.127-4.055 2.732.222 11.562 2.563 17.593 2.844 6.017 5.058 13.724 6.365 18.817 1.268 4.943 2.587 17.371 2.864 18.493'
          clipRule='evenodd'
        />
        <path
          stroke='#C3C7D9'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth={2}
          d='M130.572 264.278c-32.072 8.222-50.322-4.88-67.25-29.44-13.826-17.681-30.398-39.006-37.505-60.687-7.125-15.498-16.812-29.433-16.812-46.743.603-4.734 4.515-4.76 5.432-4.906 13.512-2.155 22.87 5.425 28.71 17.302 1.315 2.626 3.614 10.839 5.69 12.912 6.51 6.177 11.286 19.902 20.693 22.209 10.531 4.907 10.631-29.526 10.864-36.929.486-15.479-2.83-32.15-3.88-47.775-.847-12.585-4.013-25.04-4.397-37.704-.27-8.886-1.793-28.754 5.431-34.346 3.446-3.7 10.376-5.925 14.744-2.583 7.4 5.347 7.389 15.346 8.277 23.5.323 4.087.738 8.027 0 14.72 0 9.612.881 19.21 2.586 28.666 2.328 12.909-1.818 34.452 9.312 44.16 2.066 1.803 5.949-2.725 5.949-8.781-.713-11.766 1.293-23.616 1.293-35.38 0-13.013-1.892-25.99-1.811-38.994.069-10.235 1.343-37.595 16.296-38.479 17.783.855 13.399 33.978 14.226 46.484.591 8.95-.259 18.623-.259 27.632 0 23.384-5.501 39.392 2.845 40.803 10.079 1.704 10.498-31.904 11.122-38.478C163.5 67 165.5 57.5 167.5 48c0-14 3.476-38.4 19.459-31.379 9.472 7.093 6.147 25.985 5.432 36.67-.739 11.046-.643 21.952-2.328 33.056-1.346 8.867-12.563 48.153-3.104 51.908 5.541 2.245 16.648-28.303 17.847-32.023 3.646-9.907 8.694-18.95 11.64-29.181 4.469-8.926 12.523-10.328 18.106-1.808 1.558 4.119-.206 10.49-1.035 16.528-2.422 12.026-7.439 22.385-11.381 33.848-3.425 8.284-9.462 16.961-11.639 25.548C202.008 185.066 218.193 243.435 179 263c-16.176 8.852-32.273 2.159-48.428 1.278Z'
          clipRule='evenodd'
        />
        <path
          stroke='#C3C7D9'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth={2}
          d='M183.985 295.673c.263-5.509.375-14.626.617-18.966.169-3.017.186-8.568.097-14.207M100.507 296c-.277-1.114-1.592-13.453-2.856-18.359-.99-3.841-2.501-9.179-4.413-14.141'
        />
        <path
          fill='#C3C7D9'
          d='M151 121c18.4 3.6 37.667 18.5 45 25.5-8.167-5.167-24.6-17.2-41-22-16.4-4.8-49.5 6.833-62 13 11.667-7 39.6-20.1 58-16.5ZM156 158.5c-26.4-2-44-10.5-49.5-14.5 6 7.5 21.5 15.5 49.5 16.5 13.591.485 27 7.16 32 10.24-5.675-5.512-15.698-11.005-32-12.24ZM99.5 157.5c14 5.167 41.6 28.8 42 86-3.5-26.5-11-63.5-42-86ZM98 52c-4-2-13.5-3.5-19 1.5 3.167-.5 12.6-1.9 19-1.5ZM50.204 152.265c-3.489.853-9.378 5.071-8.456 11.472 1.225-2.08 4.94-8.218 8.456-11.472ZM142.923 47.907c-3.759-2.423-13.039-4.947-19.05-.575 3.202-.153 12.732-.519 19.05.575ZM227.924 98.412c-1.655-3.267-7.211-8.213-13.366-5.995 2.353.782 9.317 3.192 13.366 5.995ZM218.366 119.917c-1.655-3.267-7.211-8.212-13.366-5.995 2.353.783 9.317 3.192 13.366 5.995ZM185.785 85.244c-3.38-2.928-12.213-6.733-18.78-3.25 3.192.3 12.679 1.278 18.78 3.25ZM188.16 50.724c-3.361-2.38-11.696-4.801-17.16-.369 2.887-.187 11.478-.655 17.16.369ZM143.149 77.24c-3.706-2.164-12.649-4.057-18.084.71 3.025-.369 12.032-1.375 18.084-.71ZM98.973 85.95c-4.175-1.601-13.776-2.17-18.764 3.341 3.103-.805 12.356-3.116 18.764-3.34Z'
        />
        <BodySelectButton
          id='o-fingers-rt-thumb'
          selectedKeys={selectedKeys}
          cx={12}
          cy={12}
          r={12}
          d='M39.998 159h-8M36 155v8'
          transform='matrix(-1 0 0 1 48 147)'
        />

        <BodySelectButton
          id='o-hand-rt-palm'
          selectedKeys={selectedKeys}
          cx={12}
          cy={12}
          r={12}
          d='M141.998 195h-8M138 191v8'
          transform='matrix(-1 0 0 1 150 183)'
        />

        <BodySelectButton
          id='o-fingers-rt-second'
          selectedKeys={selectedKeys}
          cx={12}
          cy={12}
          r={12}
          d='M91.998 74h-8M88 70v8'
          transform='matrix(-1 0 0 1 100 62)'
        />

        <BodySelectButton
          id='o-fingers-rt-third'
          selectedKeys={selectedKeys}
          cx={12}
          cy={12}
          r={12}
          d='M136.998 69h-8M133 65v8'
          transform='matrix(-1 0 0 1 145 57)'
        />

        <BodySelectButton
          id='o-fingers-rt-fourth'
          selectedKeys={selectedKeys}
          cx={12}
          cy={12}
          r={12}
          d='M180.998 72h-8M177 68v8'
          transform='matrix(-1 0 0 1 189 60)'
        />

        <BodySelectButton
          id='o-fingers-rt-fifth'
          selectedKeys={selectedKeys}
          cx={12}
          cy={12}
          r={12}
          d='M221.998 105h-8M218 101v8'
          transform='matrix(-1 0 0 1 230 93)'
        />
      </g>
      <defs>
        <clipPath id='a'>
          <path fill='#fff' d='M0 0h255v296H0z' />
        </clipPath>
      </defs>
    </svg>
  );
};
export default HandRightButtons;
